import * as React from "react";
const SvgCommentFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M22 3a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v8l.007.117A1 1 0 0 0 10 12h2.003l.006 2.003.007.11a1 1 0 0 0 1.594.687l3.728-2.8H21a1 1 0 0 0 1-1zM5 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6M5 15a3 3 0 0 1 3 3v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a3 3 0 0 1 3-3" }));
export default SvgCommentFill;
